import { render, staticRenderFns } from "./formCreateRoute.vue?vue&type=template&id=7dd780d1"
import script from "./formCreateRoute.vue?vue&type=script&lang=js"
export * from "./formCreateRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd780d1')) {
      api.createRecord('7dd780d1', component.options)
    } else {
      api.reload('7dd780d1', component.options)
    }
    module.hot.accept("./formCreateRoute.vue?vue&type=template&id=7dd780d1", function () {
      api.rerender('7dd780d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/router/components/form/formCreateRoute.vue"
export default component.exports